// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"6bb5ef8f","196":"7194e904","589":"bae7eae5","601":"3f2917bc","948":"bccda04b"}[chunkId] + ".chunk.js";
};